// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__xBbRd","modalBody":"modal_modalBody__9hCMR","modalMain":"modal_modalMain__2AEi3","visible":"modal_visible__2uA2M"};